// removed by extract-text-webpack-plugin
module.exports = {"toast":"Toast__toast___2YWKB","toastClose":"Toast__toastClose___2DQXs"};


//////////////////
// WEBPACK FOOTER
// ./src/Toast.css
// module id = 11
// module chunks = 0 1